(() => {
  if (customElements.get('test-subscription-offer')) return;

  class TestSubscriptionOffer extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form[action*="/cart/add"]');
      this.planInput = this.querySelector('[data-test-selling-plan]');
      this.legalNote = this.querySelector('[data-test-legal]');
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleFormData = this.handleFormData.bind(this);

      if (!this.form || !this.planInput) return;

      this.addEventListener('change', this.handleChange);
      this.form.addEventListener('submit', this.handleSubmit, { capture: true });
      this.form.addEventListener('formdata', this.handleFormData);
      this.setMode('subscription');
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      if (!this.form) return;

      this.form.removeEventListener('submit', this.handleSubmit, { capture: true });
      this.form.removeEventListener('formdata', this.handleFormData);
    }

    handleChange(event) {
      if (!event.target.matches('[data-test-mode-radio]')) return;
      this.setMode(event.target.value);
    }

    setMode(mode) {
      const subscribed = mode === 'subscription';
      this.planInput.disabled = !subscribed;
      this.legalNote.hidden = !subscribed;

      this.querySelectorAll('[data-test-mode-radio]').forEach((radio) => {
        radio.checked = radio.value === (subscribed ? 'subscription' : 'one_time');
      });
      this.querySelectorAll('[data-test-option]').forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.testOption === (subscribed ? 'subscription' : 'one_time'));
      });
    }

    handleFormData(event) {
      const radio = this.querySelector('[data-test-mode-radio]');
      if (radio) event.formData.delete(radio.name);
    }

    handleSubmit(event) {
      const subscriptionSelected = this.querySelector('[data-test-mode-radio][value="subscription"]')?.checked;
      if (!subscriptionSelected) {
        this.planInput.disabled = true;
        return;
      }

      if (!this.planInput.value || this.planInput.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        console.error('Test subscription: missing selling plan ID.');
      }
    }
  }

  customElements.define('test-subscription-offer', TestSubscriptionOffer);
})();
